import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "../lib/cn";

const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;
const PopoverClose = PopoverPrimitive.Close;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = "center", sideOffset = 6, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "z-50 w-72 rounded-md border border-hairline bg-popover p-3 text-popover-foreground shadow-md outline-none",
        // May 28, 2026 — perceived-latency fix. ``will-change`` hints to
        // WebKit (Tauri WKWebView) to promote the content to a dedicated
        // compositor layer ahead of the open animation, eliminating the
        // 16-32 ms layer-creation stutter that was visible as part of
        // the click lag. ``transform-gpu`` (``transform: translateZ(0)``)
        // pins the layer so re-opens don't re-pay the promotion cost.
        // Paired with the 120 ms ``animate-fade-in`` defined in the
        // Tailwind preset (down from 500 ms).
        "transform-gpu will-change-[opacity,transform]",
        "data-[state=closed]:animate-fade-out data-[state=open]:animate-fade-in",
        className
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverAnchor, PopoverClose, PopoverContent };
